export class DisclaimerManagerLegalProxy {
    constructor(manager, legalEntity) {
        this.manager = manager;
        this.legalEntity = legalEntity;
    }
    getLegalEntityLabels() {
        return this.manager.getLegalEntityLabels();
    }
    registerGlobalDisclaimer(text, legalEntity) {
        const legal = legalEntity || this.legalEntity;
        this.manager.registerGlobalDisclaimer(text, legal);
    }
    registerReferenceDisclaimer(kind, text, namedReference, legalEntity) {
        const legal = legalEntity || this.legalEntity;
        return this.manager.registerReferenceDisclaimer(kind, text, namedReference, legal);
    }
    unregisterGlobalDisclaimer(text, legalEntity) {
        const legal = legalEntity || this.legalEntity;
        this.manager.unregisterGlobalDisclaimer(text, legal);
    }
    unregisterReferenceDisclaimer(kind, text, namedReference, legalEntity) {
        const legal = legalEntity || this.legalEntity;
        this.manager.unregisterReferenceDisclaimer(kind, text, namedReference, legal);
    }
    getFooterDisclaimers() {
        return this.manager.getFooterDisclaimers();
    }
    subscribe(listener, kind) {
        return this.manager.subscribe(listener, kind);
    }
    get scope() {
        return this.manager.scope;
    }
    getLegallyGroupedDisclaimers() {
        return this.manager.getLegallyGroupedDisclaimers();
    }
}
